import './App.css';
import CustomeRoutes from './CustomRoutes';

function App() {
  return (
    <div>
      <CustomeRoutes />
    </div>
  );
}

export default App;
